import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { editInvoiceItem, saveInvoicesToStorage } from '../../../models/InvoiceModel';
import { editCreditNoteItem } from '../../../models/CreditNoteModel';
import { applyDocumentDetailsFromApi, getDocumentUniqueId } from '../../../helpers/InvoiceDocumentModalHelper';
import CurrencyInput from 'react-currency-input-field';
import { useNotificationCount } from '../../../context/NotificationCountContext';

const UpdateItemModal = ({showModal, setShowModal, modalKey, invoiceData, itemData, setInvoiceData, setShippingAddress, setInvoiceItems, setCompanySettings, documentKind = 'invoice'}) => {

    const { notificationCount, setNotificationCount } = useNotificationCount();

    const navigate = useNavigate();

    const { state } = useAuth(); 

    const editor = useRef(null);

    let user_data = state.user_data;
    
    const loader = document.getElementById('loading');
    
    const [loading, setLoading] = useState(false);
    
    const [invoice_unique_id, setInvoiceUniqueId] = useState('');
    const [_item_id, setItemID] = useState('');
    const [item_title, setItemTitle] = useState('');
    //const [item_description, setItemDescription] = useState('');
    const [item_sac, setItemSac] = useState('');
    const [item_amount, setItemAmount] = useState('');
    const [item_tax, setItemTax] = useState('18');
    const [item_rate, setItemRate] = useState('');
    const [item_actual_days, setItemActualDays] = useState('');
    const [item_work_days, setItemWorkDays] = useState('');

    const [errors, setErrors] = useState({item_title:  '',  item_description: '', item_sac: '', item_amount: '', item_tax: '',item_rate: '', item_work_days: ''}); //item_actual_days: '', 
    
    const closeModal = () =>{
        setInvoiceUniqueId('');
        setItemID('');
        setItemTitle('');
        //setItemDescription('');
        setItemSac('');
        setItemAmount('');
        setItemTax('');
        setItemRate('');
        //setItemActualDays('');
        setItemWorkDays('');
        setErrors({});

        setShowModal(false);
    }

    useEffect(() => {
        //console.log(itemData);
        // This effect will be called whenever noteData changes
        if (invoiceData && itemData) {
            setInvoiceUniqueId(getDocumentUniqueId(documentKind, invoiceData));
            setItemID(itemData._item_id);
            setItemTitle(itemData.item_title);
            //setItemDescription(itemData.item_description);
            setItemSac(itemData.item_sac);
            setItemAmount(
              itemData.item_amount != null ? String(itemData.item_amount) : ''
            );
            setItemTax(itemData.item_tax != null ? String(itemData.item_tax) : '18');
            setItemRate(itemData.item_rate != null ? String(itemData.item_rate) : '');
            //setItemActualDays(itemData.item_actual_days);
            setItemWorkDays(itemData.item_work_days);
            setErrors({});
        }
      }, [invoiceData, itemData, modalKey, documentKind]);

    const currencyPrefix =
      (documentKind === 'credit_note'
        ? invoiceData?.credit_note_type
        : invoiceData?.invoice_type) === 'domestic'
        ? '₹ '
        : '$ ';

    const updateItem = async() => {
        // Start the loading state
        loader.style.display = 'block';
        setLoading(true);
    
        try {
          // Clear previous errors
          setErrors({});
    
          const formData = { item_title, item_rate, item_sac, item_amount, item_tax, item_work_days }; //item_actual_days, 
    
          const response = documentKind === 'credit_note'
            ? await editCreditNoteItem(user_data.user_token, invoice_unique_id, _item_id, formData)
            : await editInvoiceItem(user_data.user_token, invoice_unique_id, _item_id, formData);
    
          if (response?.status && response.data) {
            toast.success(response.message);
    
            closeModal();
    
            if (documentKind !== 'credit_note' && response.data?.invoices) {
              saveInvoicesToStorage(response.data.invoices, response.data.pagination);
            }
    
            applyDocumentDetailsFromApi(documentKind, response.data, {
              setInvoiceData,
              setShippingAddress,
              setInvoiceItems,
              setCompanySettings,
            });

            setNotificationCount(localStorage.getItem('unread_notification_count'));
          }
          else{
            setErrors(response.error);
            toast.error(response.message);
          }  
    
        } catch (error) {
          apiError(error);

          if (error.response?.data?.invalid_token === 1) {
            navigate('/re-login');
          }
        } finally {
        loader.style.display = 'none';
        setLoading(false);
        }
    } 


    return (
        <Modal key={modalKey} show={showModal} onHide={closeModal} size='xl'>
            <Modal.Header closeButton>
                <Modal.Title>Update Item</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
                <div className="row gy-2">
                    <div className="col-xl-6">
                        <label className="form-label">Candidate <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" placeholder="Candidate Name" 
                        value={item_title} onChange={(e) => setItemTitle(e.target.value)}/>
                        {errors.item_title && <p style={{ color: 'red' }}>{errors.item_title}</p>}
                    </div>
    
                    <div className="col-xl-6">
                        <label className="form-label">SAC </label>
                        <input type="text" className="form-control" placeholder="Services Accounting Code" 
                        value={item_sac} onChange={(e) => setItemSac(e.target.value)}/>
                        {errors.item_sac && <p style={{ color: 'red' }}>{errors.item_sac}</p>}
                    </div>
    
                    <div className="col-xl-6 d-none">
                        <label className="form-label">GST </label>
                        <input type="text" className="form-control" placeholder="GST" 
                        value={item_tax} disabled="true"/>
                        {errors.item_tax && <p style={{ color: 'red' }}>{errors.item_tax}</p>}
                    </div>
                    <div className="col-xl-6">
                        <label className="form-label">Rate <span className="text-danger">*</span></label>
                        <CurrencyInput
                            key={`rate-${modalKey}-${_item_id}`}
                            className="form-control"
                            placeholder="Enter Rate"
                            prefix={currencyPrefix}
                            value={item_rate}
                            decimalsLimit={2}
                            allowNegativeValue="false"
                            onValueChange={(value) => setItemRate(value ?? '')}
                        />
                        {errors.item_rate && <p style={{ color: 'red' }}>{errors.item_rate}</p>}
                    </div>
                    <div className="col-xl-6">
                        <label className="form-label">Amount <span className="text-danger">*</span></label>
                        <CurrencyInput
                            key={`amount-${modalKey}-${_item_id}`}
                            className="form-control"
                            placeholder="Enter Amount"
                            prefix={currencyPrefix}
                            value={item_amount}
                            decimalsLimit={2}
                            allowNegativeValue="false"
                            onValueChange={(value) => setItemAmount(value ?? '')}
                        />
                        {errors.item_amount && <p style={{ color: 'red' }}>{errors.item_amount}</p>}
                    </div>
                    {/* <div className="col-xl-6">
                        <label className="form-label">Actual Days <span className="text-danger">*</span></label>
                        <input type="number" className="form-control numeric" placeholder="Actual Days" 
                            value={item_actual_days} onChange={(e) => setItemActualDays(e.target.value)} min="0" max="31" />
                            {errors.item_actual_days && <p style={{ color: 'red' }}>{errors.item_actual_days}</p>}
                    </div> */}
                    <div className="col-xl-6">
                        <label className="form-label">Work Days <span className="text-danger">*</span></label>
                        <input type="number" className="form-control numeric" placeholder="Work Days" 
                            value={item_work_days} onChange={(e) => setItemWorkDays(e.target.value)} min="0" max="31" />
                            {errors.item_work_days && <p style={{ color: 'red' }}>{errors.item_work_days}</p>}
                    </div>
    
                    {/* <div className="col-xl-12">
                        <label className="form-label">Description </label>
    
                        <textarea className="form-control" rows="3" value={item_description} onChange={(e) => setItemDescription(e.target.value)}></textarea>
    
                        {errors.note_desc && <p style={{ color: 'red' }}>{errors.note_desc}</p>}
                    </div> */}
                    
                </div>
            </Modal.Body>
    
            <Modal.Footer>
                <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={updateItem}>
                {loading ? (
                        <>
                        <span className="spinner-border spinner-border-sm align-middle"></span>
                        Loading...
                        </>
                    ) : (     
                        'Update'
                )}
                </button>
            </Modal.Footer>
        </Modal>
      );
};


export default UpdateItemModal;